import type { UserProps } from '@img-arena/consoles-api-dde'

import { ActionDeleteItem } from '../ActionDeleteItem/ActionDeleteItem'

interface ActionDeleteDDEUserItemProps {
  onDelete: (row: UserProps) => Promise<void> | void
  displaySeparately?: boolean
}

export const ActionDeleteDDEUserItem = ({
  onDelete,
  displaySeparately = false
}: ActionDeleteDDEUserItemProps) => (
  <ActionDeleteItem
    onDelete={onDelete}
    displaySeparately={displaySeparately}
    successMessage={(row) => `User ${row.userName} deleted successfully`}
    errorMessage={(row) => `Failed to delete user ${row.userName}`}
    confirmationMessage={(row) => `Are you sure you want to delete user ${row.userName}?`}
  />
)
